import { menu as carrinhosMenu } from './checkout/carrinhos/menu';

export const crmMenu = {
    label: 'CRM',
    icon: 'pi pi-fw pi-briefcase',
    rules: [...carrinhosMenu.rules],
    items: [carrinhosMenu],
};
